import { frontendURL } from '../../../helper/URLHelper';
import CalendarIndex from './Index.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/calendar'),
    component: CalendarIndex,
    meta: {
      featureFlag: FEATURE_FLAGS.CRM,
      permissions: ['administrator', 'agent', 'contact_manage'],
    },
    children: [
      {
        path: '',
        name: 'calendar_view',
        component: CalendarIndex,
        meta: {
          featureFlag: FEATURE_FLAGS.CRM,
          permissions: ['administrator', 'agent', 'contact_manage'],
        },
      },
    ],
  },
];
